<template>
  <div class="classifyEdit-component" :style="heightCss">
    <div class="classifyEdit-container">
      <div class="global_popup_header">
        {{ title }}<i @click="$store.commit('windowHandle')"></i>
      </div>
      <div class="classifyEdit-form" v-bar>
        <el-form
          :model="form"
          ref="ruleForm"
          :rules="rules"
          label-position="top"
          @submit.native.prevent
        >
          <div class="global_popup_body">
            <div class="edit-opts" v-if="hasWrite && userInfo.roleValue === 1">
              <p class="item">{{ $t("content.books.area_lang") }}</p>
              <el-select
                v-model="form.lang"
                :placeholder="$t('placeholder.select')"
                value-key="value"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <el-form-item
              :label="$t('content.books.channelName')"
              prop="name"
              class="itemName"
            >
              <el-input
                v-model="form.name"
                :placeholder="$t('placeholder.name')"
              ></el-input>
            </el-form-item>
            <el-form-item
              v-if="channel && channel.write !== 2"
              label="类型"
              class="itemName"
            >
              <el-radio-group v-model="form.content_type">
                <el-radio
                  v-for="item in radioOpts"
                  :key="item.value"
                  :label="item.value"
                >
                  {{ item.title }}
                </el-radio>
              </el-radio-group>
            </el-form-item>
            <div v-if="form.content_type === 2">
              <el-form-item
                :label="$t('content.books.address')"
                class="itemName"
              >
                <el-input
                  v-model="form.url"
                  :placeholder="$t('placeholder.address')"
                ></el-input>
              </el-form-item>
              <el-form-item label="文本" class="itemName">
                <div class="quill-editor-main">
                  <quill-editor
                    class="quill-editor-item"
                    v-model="form.content"
                    :options="editorOption"
                  ></quill-editor>
                </div>
              </el-form-item>
            </div>
            <div v-if="hasWrite">
              <div class="edit-opts">
                <p class="item">{{ $t("content.books.showDevice") }}</p>
                <el-radio-group
                  v-model="form.device_show"
                  class="classifyEdit-radio-group"
                >
                  <el-radio :label="2">{{
                    $t("content.books.notShow")
                  }}</el-radio>
                  <el-radio :label="1">{{ $t("content.books.show") }}</el-radio>
                </el-radio-group>
              </div>
              <div class="edit-opts">
                <p class="item">{{ $t("content.books.relate") }}</p>
                <el-select
                  v-model="orgId"
                  :placeholder="$t('placeholder.select')"
                  value-key="value"
                >
                  <el-option
                    v-for="item in orgs"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </div>
              <div class="edit-opts">
                <p class="item">{{ $t("content.books.pic") }}</p>
                <div class="edit-cover">
                  <img v-if="form.cover" :src="form.cover" alt="" />
                  <img v-else :src="imageUrl" alt="" />
                  <div class="edit-upload">
                    <el-upload
                      ref="uploadCover"
                      action=""
                      :auto-upload="false"
                      class="edit-upload-btn"
                      :show-file-list="false"
                      :on-change="coverPreview"
                    >
                      <h4>{{ $t("commonMsg.replace") }}</h4>
                    </el-upload>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form>
      </div>
      <div class="global_popup_footer">
        <button @click="submitForm('ruleForm')">
          {{ $t("commonMsg.confirm") }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import { uploadOss } from "@/utils/aliyun";
import { mapGetters } from "vuex";

export default {
  props: {
    title: String,
    channel: Object,
  },
  computed: {
    ...mapGetters(["userInfo"]),
    hasWrite() {
      if (this.channel) {
        return this.channel.write !== 2;
      } else {
        return true;
      }
    },
    heightCss() {
      if (this.channel) {
        return this.channel.write === 2 ? "height: 200px" : "height: 80%";
      } else {
        return "height: 80%";
      }
    },
    options() {
      let options = [
        {
          value: "zh",
          label: this.$t("content.books.cn"),
        },
        {
          value: "tw",
          label: this.$t("content.books.tc"),
        },
        {
          value: "en",
          label: this.$t("content.books.en"),
        },
      ];
      return options;
    },
    rules() {
      let rules = {
        name: [
          { required: true, message: this.$t("verify.name"), trigger: "blur" },
        ],
      };
      return rules;
    },
  },
  data() {
    return {
      form: {
        name: "", //书单名字
        lang: "",
        cover: null,
        device_show: 2,
        url: "",
        content: "",
        content_type: 1,
      },
      radioOpts: [
        {
          title: "普通",
          value: 1,
        },
        {
          title: "Web",
          value: 2,
        },
      ],
      orgs: [],
      orgId: "",
      imageUrl: require("./cmb_book_cover.png"),
      coverFile: null,
      editorOption: {
        placeholder: " ",
        modules: {
          toolbar: [
            [
              "bold",
              "italic",
              "underline",
              { header: 1 },
              { header: 2 },
              { script: "sub" },
              { script: "super" },
              "clean",
              "image",
            ],
          ],
          history: {
            delay: 1000,
            maxStack: 50,
            userOnly: false,
          },
          imageResize: {
            displayStyles: {
              backgroundColor: "#000",
              border: "none",
              color: "white",
            },
            modules: ["Resize", "DisplaySize", "Toolbar"],
          },
        },
      },
    };
  },
  methods: {
    submitForm(formName) {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          if (this.coverFile) {
            let cover = await uploadOss(this.coverFile);
            this.form.cover = cover;
          }
          this.form.orgIds = [this.orgId];
          this.channel
            ? this.$emit("editChanndls", this.form)
            : this.$emit("createChannels", this.form);
        } else {
          return false;
        }
      });
    },
    getOrgs() {
      this.$http.getOrgList(this.params).then((res) => {
        this.orgs = res.data.rows;
      });
    },
    coverPreview(file) {
      this.coverFile = file;
      let coverUrl = URL.createObjectURL(file.raw);
      this.imageUrl = coverUrl;
    },
  },
  mounted() {
    if (this.channel) {
      this.form = Object.assign(this.form, this.channel);
      this.orgId = this.form.orgs.length ? this.form.orgs[0].id : "";
    }
    this.getOrgs();
  },
};
</script>

<style lang="scss" scoped>
.classifyEdit-component {
  @include globalPopup(60%);
  .classifyEdit-container {
    flex: 1;
    background: #fff;
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  .classifyEdit-form {
    flex: 1;
    margin-bottom: 10px;
    overflow: hidden;
  }
  .edit-opts {
    display: flex;
    margin-bottom: 20px;
    > .el-input {
      flex: 1;
    }
    > .classifyEdit-radio-group {
      padding-top: 5px;
    }
    > .item {
      width: 86px;
    }
    > p {
      margin-right: 20px;
      /* width:100px; */
    }
    .edit-cover {
      position: relative;
      /*overflow: hidden;*/
      img {
        width: 120px;
        height: 166px;
      }
      .edit-upload {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        transition: all 0.2s;
        &:hover {
          transition: all 0.2s;
          background: rgba($color: #000000, $alpha: 0.5);
          .edit-upload-btn {
            display: block;
          }
        }
        .edit-upload-btn {
          display: none;
          cursor: pointer;
          color: #fff;
          font-weight: bold;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }
  }
}

.itemIcom:before {
  content: "*";
  color: #f56c6c;
  margin-right: 4px;
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
</style>
